import { BnAction } from '../../common/bn-action';

const YEAR = 3.15e10;

const isoDate = (d = new Date()) => new Date(d).toISOString().substring(0, 10);

class WorkOrderReschedule extends BnAction {
  constructor() {
    super();
    this.actionname = 'update-scheduled-for';
    this.successtext = 'Work Order has been rescheduled.';
    this.errortext = 'An error occurred while trying to reschedule work order.';
    this.submittext = 'Reschedule';
    this.suppressheader = true;
  }

  preRender(action) {
    const field = action.getFieldByName('scheduledFor');
    field.min = isoDate();
    field.max = isoDate(new Date().getTime() + YEAR);
  }
}

window.customElements.define('work-order-reschedule', WorkOrderReschedule);
